import HomePage from "./Components/HomePage/HomePage";
import NavBar from "./Components/NavBar/NavBar";

function App() {
  return (
    <div className="">
      <NavBar />
      <HomePage />
    </div>
  );
}

export default App;
